import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const rows = [{
  bad: '3-5 hs/semana buscando recursos en internet',
  good: '10 min preparando la visita con la planilla'
}, {
  bad: 'Siempre los mismos ejercicios genéricos',
  good: '50+ protocolos adaptados a 3 niveles'
}, {
  bad: 'Familia que no sigue las indicaciones',
  good: 'Fichas visuales impresas en cada domicilio'
}, {
  bad: 'Sin documentación para la obra social',
  good: 'Informe para PAMI listo para completar'
}, {
  bad: 'Paciente que no progresa y familia que abandona',
  good: 'Indicadores funcionales medibles cada semana'
}, {
  bad: 'Sin saber qué hacer en una caída o un freezing',
  good: 'Protocolo de crisis en 30 segundos'
}, {
  bad: 'Derivaciones que nadie responde',
  good: 'Modelo de derivación que el médico lee'
}, {
  bad: 'Cero diferenciación profesional',
  good: 'Posicionamiento como TO especializado'
}];
export const Comparison = () => {
  return <section className="py-12 md:py-20 bg-cream" data-id="element-48">
      <div className="max-w-5xl mx-auto px-4" data-id="element-49">
        <div className="text-center mb-6 md:mb-12" data-id="element-50">
          <h2 className="text-[11px] md:text-sm font-bold text-teal tracking-widest uppercase mb-1 md:mb-2" data-id="element-51">
            LA REALIDAD
          </h2>
          <h3 className="text-2xl md:text-4xl font-extrabold text-navy" data-id="element-52">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </div>

        <div className="bg-white rounded-xl md:rounded-2xl shadow-lg border border-gray-200 overflow-hidden" data-id="element-53">
          <div className="grid grid-cols-2 bg-navy text-white p-3 md:p-6" data-id="element-54">
            <div className="font-bold text-center text-xs md:text-lg" data-id="element-55">
              Sin el sistema
            </div>
            <div className="font-bold text-center text-xs md:text-lg text-gold" data-id="element-56">
              Con el sistema
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-57">
            {rows.map((row, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="grid grid-cols-2 p-3 md:p-6 hover:bg-gray-50 transition-colors" data-id="element-58">
                <div className="flex items-start gap-2 md:gap-3 pr-2 md:pr-4 border-r border-gray-100" data-id="element-59">
                  <XCircle className="w-4 h-4 md:w-5 md:h-5 text-danger flex-shrink-0 mt-0.5" data-id="element-60" />
                  <span className="text-gray-600 text-xs md:text-base leading-snug" data-id="element-61">
                    {row.bad}
                  </span>
                </div>
                <div className="flex items-start gap-2 md:gap-3 pl-2 md:pl-4" data-id="element-62">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-teal flex-shrink-0 mt-0.5" data-id="element-63" />
                  <span className="text-navy font-semibold text-xs md:text-base leading-snug" data-id="element-64">
                    {row.good}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};